webpackJsonp([35783957827783],{

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/keva-after.ef53a547.jpg";

/***/ }),

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sled-work.7246434c.jpg";

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(39);
	
	__webpack_require__(40);
	
	var _Button = __webpack_require__(23);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Client = __webpack_require__(27);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Form = __webpack_require__(29);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _HalfHero = __webpack_require__(30);
	
	var _HalfHero2 = _interopRequireDefault(_HalfHero);
	
	var _Header = __webpack_require__(31);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Hero = __webpack_require__(32);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _IconList = __webpack_require__(33);
	
	var _IconList2 = _interopRequireDefault(_IconList);
	
	var _Testimonial = __webpack_require__(34);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	var _Testimonials = __webpack_require__(35);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _kevaAfter = __webpack_require__(156);
	
	var _kevaAfter2 = _interopRequireDefault(_kevaAfter);
	
	var _sledWork = __webpack_require__(609);
	
	var _sledWork2 = _interopRequireDefault(_sledWork);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import menu from '../scripts/menu.js';
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Hero2.default,
	      { image: _sledWork2.default },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'CustomFIT Personal Training'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Personal training done right.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit. Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.'
	      ),
	      _react2.default.createElement(
	        _Button2.default,
	        { to: '#get-started' },
	        'Get Started!'
	      )
	    ),
	    _react2.default.createElement(
	      _IconList2.default,
	      { title: 'Services' },
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Personal Training'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Individual training with personal attention to teach proper techniques and monitor progress.'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { to: 'services/#personal-training' },
	          'Learn More!'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Small Group Training'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Great way to stay motivated and challenged with others working out alongside you.'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { to: 'services/#small-group-training' },
	          'Learn More!'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Boxing'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Learn the ropes from someone who has been in the ring! Not just a certified instructor.'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { to: 'services/#boxing' },
	          'Learn More!'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Meal Prepping'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.'
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { to: 'services/#meal-prep' },
	          'Learn More!'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Client2.default,
	      {
	        featured: true,
	        name: 'Keva S.',
	        image: _kevaAfter2.default,
	        id: 'keva' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'I met Jerron November 11, 2016. I remember this day because I had less than 8 months to meet the fitness standards my job requires or be fired. I am 5\u20196, weighed 250 pounds and measured at 46% body fat. I admit I was skeptical, but also desperate, so I gave him a shot. Best decision I could have made! I am happy to report that 20 days before I was to be terminated, I weighed in at 191 lbs and 34% body fat. I am still happily employed and no longer worry how I\u2019m going to support my family without a job. November 11, 2017 I weighed in at 187 pounds, 32% body fat and the gains keep coming! If you need a trainer or are just curious, go with Jerron you won\u2019t be sorry.'
	      )
	    ),
	    _react2.default.createElement(
	      _Testimonials2.default,
	      {
	        title: 'Client Success Stories' },
	      _react2.default.createElement(
	        _Testimonial2.default,
	        {
	          to: '/testimonials#jennifer',
	          cite: 'Jennifer T.' },
	        _react2.default.createElement(
	          'p',
	          null,
	          '\u201CThe one-on-one personalized sessions put me at ease since the gym has never been my friend. In the 4 months that I have trained with CustomFIT I have successfully lost and kept off 27 pounds.\u201D'
	        )
	      ),
	      _react2.default.createElement(
	        _Testimonial2.default,
	        {
	          to: '/testimonials#2',
	          cite: 'Another Person' },
	        _react2.default.createElement(
	          'p',
	          null,
	          '\u201CThe one-on-one personalized sessions put me at ease since the gym has never been my friend. In the 4 months that I have trained with CustomFIT I have successfully lost and kept off 27 pounds.\u201D'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-017adc2d88cd21661202.js